import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    finishConfigurationSheetButton: {
      minWidth: '245px',
      backgroundColor: '#3560FF',
      border: 'none',
    },
    sheetConfiguredButton: {
      display: 'inline-flex',
      width: '400px',
      color: '#347F42',
      marginLeft: '15px',
      pointerEvents: 'none',
    },
    examSheetBeConfiguredResultsList: {
      textAlign: 'left',
      width: '450px',
      margin: 'auto',
      listStyleType: 'none',
      '& li': {
        margin: '5px 0 5px 0',
        '& svg': {
          width: '20px',
          marginRight: '15px',
          position: 'relative',
          top: '7px',
        },
      },
    },
    successIcon: {
      color: '#347F42',
    },
    errorIcon: {
      color: '#BC0000',
    },
    warningHeader: {
      fontWeight: 'bold',
      marginLeft: '20px',
    },
    examSheetBeConfiguredWarningList: {
      textAlign: 'left',
    },
    retentionRow: {
      width: '350px',
    },
    retentionText: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 14,
      color: '#2C2D3E',
    },
    fileWrapper: {
      paddingBottom: '10px',
      width: '350px',
    },
  }),
);
